export const minutesToHours = (minutes: number) => Number.isFinite(minutes) ? parseFloat((minutes / 60).toFixed(2)) : null;
